import { Button, Modal } from "antd";
import React from "react";

interface ModalProps {
  width: number;
  visible: boolean;
  onClose: () => void;
  title: string;
  content: React.ReactNode; // Giữ nguyên kiểu React.ReactNode
  footer: any;
}

const GenericModal: React.FC<ModalProps> = ({ width, visible, onClose, title, content, footer }) => {
  return (
    <Modal
      width={width ?? 500} 
      title={title}
      open={visible}
      onCancel={onClose}
      footer={footer}
    >
      {content} 
    </Modal>
  );
};

export default GenericModal;